import { useEffect, useState } from 'react';
import { Table, Modal } from 'antd';
import {
    useParams
} from "react-router-dom";
import AddEditTransactionForm from "./addEditTransactionForm"
import { backendUrl } from '../../Config';
import { ajaxFetchCall } from '../../services/ApiService';
import { convertToGraphQl, createGraphQlFilters, createSortOrder } from '../../services/GarphQlConversionService';
import { getTransactionColumns } from "./config.js"
import Worth from './worth';

export default function Transactions(props) {

    let { mfId } = useParams();
    let [nav, setNav] = useState("")
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editTransaction, setEditTransaction] = useState({})
    const [mf, setMf] = useState({})
    const graphqlName = "GrowwMutualFundPagination"
    const userTransactionPaginationGraphqlName = "UserTransactionPagination"
    const navGraphqlName = "GrowwMutualFundNavPagination"
    const [dataSource, setDataSource] = useState([])

    useEffect(() => {
        initialize()
    }, [])

    const initialize = async () => {
        getMf()
        getLatestNavOfMF()
        getTransactions()
    }

    const handleTransactionDelete = async (id) => {
        let data = await ajaxFetchCall(backendUrl + "/user/transaction/" + id, { method: "DELETE" })
        initialize();
    }
    const showModal = async (transactionId) => {
        await getTransactionById(transactionId)
        setIsModalVisible(true);
    };

    const [columns, setColumns] = useState(getTransactionColumns(handleTransactionDelete, showModal))


    const getTransactionById = async (transactionId) => {
        let q1 = convertToGraphQl(userTransactionPaginationGraphqlName, createGraphQlFilters({ _id: [transactionId] }), ["action",
            "date", "nav", "amount", "quantity", "investedBy", `mf {
                fund_name    
                _id
              }`], null, 1, 1)
        let body = JSON.stringify({
            query: q1
        });
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        setEditTransaction(data["data"][userTransactionPaginationGraphqlName]["items"][0])
    }


    const getLatestNavOfMF = async () => {
        let sortObj = { column: "date", "columnKey": "date", "order": "descend" }
        let order = createSortOrder(sortObj)
        let q1 = convertToGraphQl(navGraphqlName, createGraphQlFilters({ mutualFund: [mfId] }), ["nav", "shareNavPredict", "date"], order, 1, 1,)

        let body = JSON.stringify({
            query: q1
        });
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        if (data["data"][navGraphqlName]["items"] && data["data"][navGraphqlName]["items"][0]) {
            if (data["data"][navGraphqlName]["items"][0]['nav']) {
                setNav(data["data"][navGraphqlName]["items"][0]['nav'])
            } else {
                setNav(data["data"][navGraphqlName]["items"][0]['shareNavPredict'])
            }
        }
    }

    const getMf = async () => {
        const graphqlFilters = createGraphQlFilters({ _id: [mfId] })
        let q1 = convertToGraphQl(graphqlName, graphqlFilters, ['scheme_name'], null, 1, 1)
        let body = JSON.stringify({
            query: q1
        });
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        setMf(data["data"][graphqlName]["items"][0])
    }

    const getTransactions = async () => {
        let data = await ajaxFetchCall(backendUrl + "/user/transaction/" + mfId)
        let tempTotalProfit = 0;
        let tempTotalQuantity = 0;
        let tempTotalInvested = 0;
        for (let l of data['response']) {
            if (l.action == 'Buy') {
                tempTotalInvested += l.amount
                tempTotalQuantity += l.quantity
            } else {
                tempTotalInvested = tempTotalInvested - l.amount
                tempTotalQuantity -= l.quantity
            }
        }
        let tempCurrentValue = (tempTotalQuantity * nav).toFixed(2)
        tempTotalProfit = tempCurrentValue - tempTotalInvested
        setDataSource(data['response'])
    }

    const handleCancel = () => {
        setIsModalVisible(false);
    }

    const onFinish = async (values) => {
        if (values.nav) {
            values['date'] = values['date'].startOf('day')
            let data = await ajaxFetchCall(backendUrl + "/user/transaction/" + values.transactionId, {
                method: "PUT",
                body: JSON.stringify(values)
            })
            setIsModalVisible(false)
            initialize()
        }
    }

    return (
        <div>
            Mutual Fund : {mf.scheme_name}
            <Modal title="Edit Transaction" destroyOnClose={true} footer={null} visible={isModalVisible} onCancel={handleCancel} handleCancel={handleCancel}>
                <AddEditTransactionForm onFinish={onFinish}
                    action={editTransaction.action}
                    investedBy={editTransaction.investedBy}
                    mf={editTransaction?.mf?._id}
                    date={editTransaction.date}
                    amount={editTransaction.amount}
                    transactionId={editTransaction._id}
                ></AddEditTransactionForm>
            </Modal>
            <Worth transactions={dataSource}></Worth>
            <Table className="mt-10" rowKey="_id" dataSource={dataSource} columns={columns} pagination={false} />
        </div>
    )
}